import { useLocation, Link } from "@tanstack/react-router";
import { ICLogo } from "@/components/Icon/ICLogo";
import Language from "@/components/Layout/Navbar/language";
import CardInfo from "@/components/Card";
import LoginButton from "@/components/Layout/Navbar/LoginButton/LoginButton";
import UserInfo from "@/components/Layout/Navbar/UserInfo/UserInfo";
import MobileNavigation from "@/components/Layout/Navbar/Navigation/Mobile";
import DesktopNavigation from "@/components/Layout/Navbar/Navigation/Desktop";
import NetworkSituation from "@/components/Layout/Navbar/NetworkSituation";
import { useAuth } from "@/provider/AuthProvider";

export default function Navigation() {
  const privyToken = localStorage.getItem("privy:token");
  const { isAuthenticated } = useAuth();

  const location = useLocation();

  // Render Navbar for other routes
  return (
    <header className="bg-[#151517]">
      <header className="flex justify-between items-center p-4 max-w-[1280px] mx-auto">
        <Link
          to="/"
          className={`flex items-center space-x-2 ${location.pathname === "/not-found" ? "pointer-events-none opacity-50" : ""}`}
        >
          <ICLogo width="40" height="40" />
          <span className="text-xl font-bold text-white"> MoneyFi </span>
          {/* Desktop Navigation (hidden on mobile, visible on sm and above) */}
        </Link>
        <DesktopNavigation />
        <aside className="flex items-center justify-center">
          {privyToken ? <NetworkSituation /> : null}
          <Language />
          <div className="lg:hidden">
            <MobileNavigation />
          </div>

          <div className="hidden lg:flex items-center space-x-2">
            {isAuthenticated ? (
              <CardInfo className="flex items-center justify-center">
                <UserInfo />
              </CardInfo>
            ) : (
              <LoginButton />
            )}
          </div>
        </aside>
      </header>
    </header>
  );
}
